import exclamationIcon from "@assets/images/exclamation.svg";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";

import TableUploadFail from "../TableUploadFail";
import useStyles from "./styles";

interface DialogCustomerBlockProps {
  onConfirm: () => void;
  open: boolean;
  data: any[];
}

const DialogCustomerBlock: React.FC<DialogCustomerBlockProps> = ({
  onConfirm,
  open,
  data
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onConfirm}
      className={classes.root}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle>
        <SVG src={exclamationIcon} />
        <MyTypography variant="h6" style={{ marginBottom: "5px" }}>
          อัปโหลดไฟล์ไม่สำเร็จ
        </MyTypography>
        <MyTypography variant="h7">
          เนื่องจากข้อมูลผิดพลาด <strong>{data.length}</strong> records
        </MyTypography>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <TableUploadFail tableData={data} />
      </DialogContent>
      <DialogActions disableSpacing={true}>
        <Button
          color="primary"
          variant="contained"
          className={classNames(classes.typeButton, "gradient")}
          onClick={onConfirm}
        >
          <MyTypography variant="body1">ปิดหน้าต่าง</MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogCustomerBlock;
